export default __webpack_public_path__ + "static/media/present-icon-blue.7c82c873.svg";